module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Radera":"Remove","Avbryt":"Cancel","Föreg.":"Prev.","Stäng":"Close","Spara & stäng":"Save & close","Nästa":"Next","Slutför":"Finish","asd":"asd"},"sv":{"Radera":"Radera","Avbryt":"Avbryt","Föreg.":"Föreg.","Stäng":"Stäng","Spara & stäng":"Spara & stäng","Nästa":"Nästa","Slutför":"Slutför","asd":"asd"}}')
  delete Component.options._Ctor
}
